import Routes from './routes';
import './App.scss';
import "owl.carousel/dist/assets/owl.carousel.css";
import "owl.carousel/dist/assets/owl.theme.default.css";

function App() {
  return (
    <Routes />
  );
}

export default App;
